import { NgModule } from 'ng-metadata/core';
import { AuthenticationComponent } from './authentication.component';

@NgModule({
  declarations: [AuthenticationComponent],
})
export class AuthenticationModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/authentication/authentication.module.ts